import { dispatchThunk } from 'app/store';
import {
  getFormValue,
  getOfferFromSelector,
  getQuotation,
  setMessageVisibility,
  getPromotion,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  VehicleTypeEnum,
} from 'app/shared/enums';
import { checkPromotionCode } from 'app/store/data/promotionalCode';

const formName = FormsEnum.CheckoutForm;

const setPromotionCodeMessagesVisibility = (promotionId: string) => {
  const {
    expiredPromotion,
    promotionForAcOnly,
    promotionForRenewalOnly,
    promotionOfferPriceTooLow,
  } = getPromotion();

  setMessageVisibility({
    key: MessagesEnum.CheckoutPromotionCodeIncorrect,
    visible: expiredPromotion === promotionId,
    formName,
  });

  setMessageVisibility({
    key: MessagesEnum.CheckoutPromotionCodeForAcOnly,
    visible: promotionForAcOnly === promotionId,
    formName,
  });

  setMessageVisibility({
    key: MessagesEnum.CheckoutPromotionCodeForRenewalOnly,
    visible: promotionForRenewalOnly === promotionId,
    formName,
  });

  setMessageVisibility({
    key: MessagesEnum.CheckoutPromotionCodeOfferPriceTooLow,
    visible: promotionOfferPriceTooLow === promotionId,
    formName,
  });
};

const promotionCode = {
  onCheckoutPromotionCodeChange(initialRun: boolean) {
    const promotionId = getFormValue(FieldsEnum.CheckoutPromotionId, formName);
    const offer = getOfferFromSelector();
    const quotation = getQuotation();

    if (initialRun || quotation.vehicleType === VehicleTypeEnum.Motorcycle) {
      return;
    }

    dispatchThunk(
      checkPromotionCode({
        quotationId: quotation.id,
        promotionId: promotionId || null,
        promotionPartnerId: null,
        resultId: offer?.resultId || null,
        offerId: offer?.id || null,
        changeCodeTriggeredByUser: true,
      })
    ).then(() => {
      setPromotionCodeMessagesVisibility(promotionId);
    });
  },
};

export default promotionCode;
